import { lazy, Suspense } from "react";

import { PlaygroundLoadError } from "@/ds/playground/playground-load-error";
import { AppLayout } from "@/modules/global/layout";
import { AuthCallbackPage } from "@/pages/auth-callback";
import { HomePage } from "@/pages/home";
import { LoginPage } from "@/pages/login";
import { RequestAccessPage } from "@/pages/request-access";
import { Paths } from "@/core/constants/paths";
import type { ExtendedRouteObject } from "./types";

/** Playground do DS: só em desenvolvimento; o `import()` sai do build de produção junto com o guard. */
function createDsPlaygroundRoute(): ExtendedRouteObject {
  // Falha ao carregar o chunk (ex.: reotimização do Vite) aparece na tela em vez de página em branco.
  const DsPlaygroundPage = lazy(() =>
    import("@/ds/playground")
      .then((module) => ({ default: module.DsPlayground }))
      .catch((error: unknown) => ({
        default: () => <PlaygroundLoadError message={String(error)} />,
      })),
  );

  return {
    path: "/ds-playground/:item?",
    element: (
      <Suspense fallback={null}>
        <DsPlaygroundPage />
      </Suspense>
    ),
    rules: ["public"],
  };
}

const devRoutes: ExtendedRouteObject[] = import.meta.env.DEV ? [createDsPlaygroundRoute()] : [];

/** Rotas públicas (sem autenticação) */
export const publicRoutes: ExtendedRouteObject[] = [
  {
    path: Paths.LOGIN,
    element: <LoginPage />,
    rules: ["public"],
  },
  {
    path: Paths.AUTH_CALLBACK,
    element: <AuthCallbackPage />,
    rules: ["public"],
  },
  {
    path: Paths.REQUEST_ACCESS,
    element: <RequestAccessPage />,
    rules: ["public"],
  },
  ...devRoutes,
];

/** Rotas autenticadas — home e demais telas do app */
export const authenticatedRoutes: ExtendedRouteObject[] = [
  {
    element: <AppLayout />,
    rules: ["user"],
    scope: ["workspace"],
    children: [
      {
        path: Paths.HOME,
        element: <HomePage />,
        rules: ["user"],
        scope: ["workspace"],
      },
    ],
  },
];
